/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { BrightHorizonsExitPartnership } from './model/brightHorizonsExitPartnership';

export const apiBrightHorizonsExitPartnershipDestroy = () => {
  return HTTP<BrightHorizonsExitPartnership>({
    url: `/api/v7/bright-horizons/exit-partnership/`,
    method: 'DELETE',
  });
};

export const getApiBrightHorizonsExitPartnershipDestroyMutationOptions = <
  TError = ErrorType<BrightHorizonsExitPartnership>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['apiBrightHorizonsExitPartnershipDestroy'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    void
  > = () => {
    return apiBrightHorizonsExitPartnershipDestroy();
  };

  return { mutationFn, ...mutationOptions };
};

export type ApiBrightHorizonsExitPartnershipDestroyMutationResult = NonNullable<
  Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>
>;

export type ApiBrightHorizonsExitPartnershipDestroyMutationError =
  ErrorType<BrightHorizonsExitPartnership>;

export const useApiBrightHorizonsExitPartnershipDestroy = <
  TError = ErrorType<BrightHorizonsExitPartnership>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof apiBrightHorizonsExitPartnershipDestroy>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getApiBrightHorizonsExitPartnershipDestroyMutationOptions(options);

  return useMutation(mutationOptions);
};
